import { usePageId } from '@marketplace-web/shared/request'
import { SearchBarSearchType } from '@marketplace-web/search/search'

export function useHeaderSearchType(): SearchBarSearchType {
  const pageId = usePageId()

  if (pageId?.startsWith('member')) return SearchBarSearchType.User
  if (pageId?.startsWith('help')) return SearchBarSearchType.Faq

  return SearchBarSearchType.Item
}
